"use client";
import type { Prisma } from "@-/prisma";
import type { employeeProfileInclude } from "@/app/(actor)/[organization-slug]/team-members/include";
import type { ProfileReferralDetails } from "@/utils/host-family-referrals.server";
import { createContext } from "react";
import type { TeamMemberPayoutSettings } from "./direct-deposit-access.server";

export type TeamMemberLayoutContext = {
  canEditEmployeeInformation: boolean;
  canManageEmployee: boolean;
  acquisitionSourceReadOnly: boolean;
  employeeProfile: Prisma.EmployeeProfileGetPayload<{
    include: typeof employeeProfileInclude;
  }>;
  incomingReferral: ProfileReferralDetails | null;
  payoutSettings: TeamMemberPayoutSettings;
};

const LayoutContext = createContext<TeamMemberLayoutContext>(null!);

export default LayoutContext;
